import { t } from 'i18next'

export const MAX_ITEMS = 5

export const CONTEXT_MENU_ANCHOR_POSITION = {
  vertical: 'bottom',
  horizontal: 'center',
}

export const CONTEXT_MENU_ID = 'positioned-menu'
export const EXPORT_WIDGETS = 'export-widgets'

export const CORE_PACKAGE = 'Core'

export const BRAND_NAME = t('core:breadcrumbBrand')

export const URL_PREFIX = window.location.host.split('.')[0]
